import { render, staticRenderFns } from "./setup-password.vue?vue&type=template&id=440c22e9&scoped=true&"
import script from "./setup-password.vue?vue&type=script&lang=ts&"
export * from "./setup-password.vue?vue&type=script&lang=ts&"
import style0 from "./setup-password.vue?vue&type=style&index=0&id=440c22e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440c22e9",
  null
  
)

export default component.exports